<template>
  <div class="form_wrapper">
    <h1>重置密码</h1>
    <!-- <div class="text_hover_light_primary back_login">
      <i class="el-icon-arrow-left"></i>返回登录
    </div> -->
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      size="small">
      <el-form-item prop="mobile">
        <el-input
          type="text"
          :maxlength="11"
          v-model.trim="form.mobile"
          size="small"
          placeholder="请输入手机号">
        </el-input>
      </el-form-item>
      <el-form-item prop="captchaCode">
        <div class="captcha">
          <el-input class="captcha_input" size="small" placeholder="请输入图形验证码" v-model.trim="captchaCode" />
          <img class="captcha_img" :src="captcha.url" title="点击刷新" alt="" @click="refreshImageCaptcha" />
        </div>
      </el-form-item>
      <el-form-item prop="smsCode" style="">
        <el-input
          size="small"
          placeholder="请输入短信验证码"
          v-model="form.smsCode"
          class="my-el-input__inner-group__append append_primary_plain vertical-align-middle">
          <el-button
            type="primary"
            plain
            slot="append"
            size="small"
            :disabled="!(canGetSms && validateFieldMobile)"
            @click="handleSendSms">{{ sendSmsBtnText }}
          </el-button>
        </el-input>
      </el-form-item>
      <div @keyup.enter="submitBefore">
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model.trim="form.password"
            size="small"
            placeholder="请输入密码">
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <!-- 提交按钮 -->
    <div class="submit_btn flex flex_direction">
      <el-button
        type="primary"
        size="small"
        :loading="submitBtnLoading"
        @click="submitBefore">
        确 定
      </el-button>
      <span class="text_size_12 text_hover_light_primary margin-top-10" @click="backLogin"><i class="el-icon-arrow-left"></i>返回登录</span>
    </div>
  </div>
</template>

<script>
import * as api from '~/api'
import SHA256 from 'crypto-js/sha256'
export default {
  data () {
    return {
      // 提交表单button的loading
      submitBtnLoading: false,
      // 发送短信按钮的文字
      sendSmsBtnText: '发送验证码',
      // 是否可以获取短信验证码
      canGetSms: true,
      // 图形验证码
      captchaCode: '',
      captcha: {
        url: '',
        tk: ''
      },
      // 登录信息
      form: {
        // 目前为手机号
        mobile: '',
        // 短信验证码
        smsCode: '',
        // 密码
        password: ''
      },
      // 登录表单验证规则
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { pattern: /^[0-9]{6}$/, message: '验证码格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}$/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // 对手机号进行校验
    validateFieldMobile () {
      if (this.form.mobile && /^1\d{10}$/.test(this.form.mobile)) {
        return true
      }
      return false
    },
    validateCaptchaCode () {
      if (this.captchaCode && /^[a-zA-Z0-9]+$/.test(this.captchaCode)) {
        return true
      }
      this.$message.warning('请输入图形验证码')
      return false
    }
  },
  mounted () {
    this.getImageCaptcha()
  },
  methods: {
    // 获取短信验证码
    handleSendSms () {
      if (!(this.canGetSms && this.validateFieldMobile && this.validateCaptchaCode)) return
      this.canGetSms = false
      api.sendSms({
        mobile: this.form.mobile,
        tk: this.captcha.tk,
        captchaCode: this.captchaCode
      }).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          let count = 60
          this.sendSmsBtnText = `已发送(${count}s)`
          let interval = setInterval(() => {
            if (count <= 0) {
              clearInterval(interval)
              this.sendSmsBtnText = '发送验证码'
              this.canGetSms = true
            } else {
              count--
              this.sendSmsBtnText = `已发送(${count}s)`
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
          this.canGetSms = true
          console.log(res)
        }
      }).catch((error) => {
        alert('网络错误，请重试！')
        this.canGetSms = true
        console.log(error)
      })
    },

    // 进行验证
    submitBefore () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // 重置密码
          this.resetPassword()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 重置密码
    resetPassword () {
      this.submitBtnLoading = true
      api.changePassword({
        ...this.form,
        password: SHA256(this.form.password).toString()
      }).then(res => {
        if (res.data.code === 0) {
          console.log('修改密码成功')
          // 返回登录
          this.backLogin()
        } else {
          this.$message.error(res.data.message)
          console.log(res)
        }
        this.submitBtnLoading = false
      }).catch((error) => {
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
        this.submitBtnLoading = false
      })
    },

    // 重置表单 (让父组件关闭的时候重置此表单)
    resetForm () {
      this.$refs['form'].resetFields()
    },

    // 返回登录
    backLogin () {
      this.$emit('changeView', 'loginForm')
    },

    // 获取图片验证码
    getImageCaptcha () {
      api.getImageCaptcha().then(res => {
        if (res.data.code === 0) {
          this.captcha = {
            tk: res.data.data.tk,
            url: res.data.data.url + '?w=99&h=33'
          }
          console.log(this.captcha.url)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    // 刷新图片验证码
    refreshImageCaptcha () {
      let dateNow = new Date()
      this.captcha.url = `${this.captcha.url.split('?')[0]}?d=${dateNow.valueOf()}&w=99&h=33`
    }
  }
}
</script>

<style lang="scss" scoped>
  .form_wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 325px;
    padding: 12px 110px 0 110px;
    & > h1 {
      width: 100%;
      text-align: center;
      font-size: 18px;
      font-weight:bold;
      line-height:25px;
      color: #000000;
      margin-bottom: 20px;
    }
    .captcha {
      display: flex;
      &_input {
        flex: 1;
      }
      &_img {
        width: 99px;
      }
    }
    .submit_btn {
      display: flex;
      justify-content: center;
      margin-top: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/form-dialog/resetpwd-form.vue